export const resizeFile = async (file) => {

    const imageBlob = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = async (e) => {
            const imageBlob = await loadImageAndResize(file, e)
            resolve(imageBlob)
        }
        reader.readAsDataURL(file);
    })
    return imageBlob

}

const loadImageAndResize = async (file, e) => {

    const imageBlob = await new Promise((resolve) => {
        const img = new Image()
        img.onload = async () => {
            let width = img.width
            let height = img.height
            const canvas = document.createElement("canvas");
            handleAutoResize(img, canvas, width, height)
            const blob = await new Promise(resolve => canvas.toBlob(resolve, "image/jpeg"));
            resolve(blob)
        }
        img.src = e.target.result
    })
    return imageBlob

}

const handleAutoResize = (img, canvas, originalWidth, originalHeight) => {

    const MAX_WIDTH = 1440;
    const MAX_HEIGHT = 810;

    let height = 0
    let width = 0

    if (originalWidth > MAX_WIDTH || originalHeight > MAX_HEIGHT) {
        if (originalWidth > MAX_WIDTH) {
            if (MAX_WIDTH * (originalHeight / originalWidth) >= MAX_HEIGHT) {
                width = MAX_WIDTH
                height = MAX_WIDTH * (originalHeight / originalWidth)
                canvas.width = MAX_WIDTH
                canvas.height = MAX_HEIGHT
                //center and done
                centerImageInCanvas(img, width, height, canvas)
            } else {
                width = originalWidth
                height = originalHeight
                canvas.width = originalHeight * (16 / 9)
                canvas.height = originalHeight
                //center and done
                centerImageInCanvas(img, width, height, canvas)
            }
        } else {
            width = originalWidth
            height = originalHeight
            if (originalHeight > MAX_HEIGHT) {
                canvas.width = originalWidth
                canvas.height = originalWidth * (9 / 16)
                //center and done
                centerImageInCanvas(img, width, height, canvas)
            } else {
                canvas.width = originalHeight * (16 / 9)
                canvas.height = originalHeight
                //center and done
                centerImageInCanvas(img, width, height, canvas)
            }
        }
    } else {
        width = originalWidth
        height = originalHeight
        if (width > height && (originalWidth * (9 / 16)) < originalHeight) {
            canvas.width = originalWidth
            canvas.height = originalWidth * (9 / 16)
            //center and done
            centerImageInCanvas(img, width, height, canvas)
        } else {
            canvas.width = originalHeight * (16 / 9)
            canvas.height = originalHeight
            //center and done
            centerImageInCanvas(img, width, height, canvas)
        }

    }

}

const centerImageInCanvas = (img, width, height, canvas) => {

    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "rgb(0,0,255)"
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    let x = 0
    let y = 0
    if (width > canvas.width) {
        x = -((width - canvas.width) / 2)
    }
    if (height > canvas.height) {
        y = -((height - canvas.height) / 2)
    }
    ctx.drawImage(img, x, y, width, height);
}

export const blobToDataURL = async (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = _e => resolve(reader.result);
        reader.onerror = _e => reject(reader.error);
        reader.onabort = _e => reject(new Error("Read aborted"));
        reader.readAsDataURL(blob);
    });
}

export const handleVideoFile = async (file) => {

    const videoArray = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = async (e) => {
            const arrayBuffer = e.target.result
            const array = new Uint8Array(arrayBuffer)
            resolve(array)
        }
        reader.readAsArrayBuffer(file);
    })
    return videoArray

}